<template>
  <div class="festival-nav">
    <div class="festival-nav__tabs">
      <div
        v-for="tab in tabs"
        :key="tab.path"
        class="festival-nav__tab"
        :class="{ 'festival-nav__tab--active': tab.path === activePath }"
        @click="go(tab.path)"
      >
        <i :class="tab.icon" />
        <span>{{ tab.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FestivalOpsNav',
  props: {
    activePath: { type: String, default: '/festival/workbench' }
  },
  data() {
    return {
      tabs: [
        { path: '/festival/workbench', label: '运营概览', icon: 'el-icon-data-analysis' },
        { path: '/festival/decorate', label: '活动装修', icon: 'el-icon-edit-outline' },
        { path: '/festival/products', label: '商品库', icon: 'el-icon-goods' },
        { path: '/festival/orders', label: '订单履约', icon: 'el-icon-box' }
      ]
    }
  },
  methods: {
    go(path) {
      if (path === this.activePath) return
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="scss" scoped>
.festival-nav { margin-bottom: 16px; }
.festival-nav__tabs {
  display: flex;
  gap: 6px;
  padding: 8px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow-x: auto;
}
.festival-nav__tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 6px;
  color: #5b6472;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}
.festival-nav__tab:hover { color: #b42318; background: #fff7f3; }
.festival-nav__tab--active { color: #fff; background: linear-gradient(135deg, #cf2f23 0%, #9f1d1d 100%); }
</style>
